import { createSlice } from '@reduxjs/toolkit';

import { retrieveJob } from '../../sdk/apis';
import Job from '../../sdk/containers/Job';
import { getMunicipalities as getMunicipalitiesAPI , getOptional as getOptionalAPI,getPrefs as getPrefsAPI , registerJob as registerJobAPI  } from './requests';




const WATCH_INTERVAL_MSEC = 5000;

export const PREPARING = 1;
export const REGISTERING = 2;
export const WAITING = 3;
export const DOWNLOADING = 4;

export const manualSlice = createSlice({
  name: 'manual',
  initialState: {
    prefs: null,
    municipalities: null,
    jobId: null,
    job: null,
    status: PREPARING,
    intervalId: null,
    optional: null,
  },
  reducers: {
    setPrefs: (state, action) => {
      state.prefs = action.payload;
    },
    setMunicipalities: (state, action) => {
      state.municipalities = action.payload;
    },
    setJobId: (state, action) => {
      state.jobId = action.payload;
    },
    setJob: (state, action) => {
      state.job = action.payload;
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setIntervalId: (state, action) => {
      state.intervalId = action.payload;
    },
    setOptional: (state, action) => {
      state.optional = action.payload;
    }
  },
});

export const { setPrefs, setMunicipalities, setJobId, setJob, setStatus, setIntervalId, setOptional } = manualSlice.actions;

export function registerJobAndWait(setting) {
  return (dispatch, getState) => {
    dispatch(setStatus(REGISTERING));

    registerJobAPI(setting).then((jobId) => {
      dispatch(setJobId(jobId));

      const watchJob = async () => {
        const job = await retrieveJob(jobId);
        dispatch(setJob(job));
        if (job.status === Job.FINISHED) {
          const s = getState();
          clearInterval(s.manual.intervalId);

          const url = window.Urls['manual_api:download_zip'](jobId);
          document.location.href = url;

          dispatch(setJob(null));
          dispatch(setStatus(PREPARING));
        } else {
          dispatch(setStatus(WAITING));
        }
      }

      dispatch(setIntervalId(setInterval(watchJob, WATCH_INTERVAL_MSEC)));
    })
  }
}

export function loadPrefs() {
  return (dispatch) => {
    setTimeout(() => {
      getPrefsAPI().then((prefs) => {
        dispatch(setPrefs(prefs));
      });
    }, 1000);
  }
}

export function loadMunicipalities(pref_id) {
  return (dispatch) => {
    getMunicipalitiesAPI(pref_id).then((data) => {
      dispatch(setMunicipalities(data));
    });
  }
}

export function loadOptional(area_id) {
  return (dispatch) => {
    getOptionalAPI(area_id).then((data) => {
      dispatch(setOptional(data));
    });
  }
}

export default manualSlice.reducer
